import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const OutdentIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Outdent",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M28.44 3.56H3.56C2.7 3.56 2 4.26 2 5.12s.7 1.56 1.56 1.56h24.89c.86 0 1.56-.7 1.56-1.56s-.7-1.56-1.56-1.56Zm0 21.78H3.56c-.86 0-1.56.7-1.56 1.56s.7 1.56 1.56 1.56h24.89c.86 0 1.56-.7 1.56-1.56s-.7-1.56-1.56-1.56Zm0-14.52H17.03c-.86 0-1.56.7-1.56 1.56s.7 1.56 1.56 1.56h11.41c.86 0 1.56-.7 1.56-1.56s-.7-1.56-1.56-1.56m0 7.26H17.03c-.86 0-1.56.7-1.56 1.56s.7 1.56 1.56 1.56h11.41c.86 0 1.56-.7 1.56-1.56s-.7-1.56-1.56-1.56m-19.7 4.77c.27.25.64.41 1.05.41.86 0 1.55-.69 1.56-1.55V10.3c0-.86-.7-1.55-1.56-1.55-.4 0-.77.15-1.05.41s-6.22 5.7-6.22 5.7a1.55 1.55 0 0 0 0 2.28s6.22 5.7 6.22 5.7Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M28.14 7.14H3a1.14 1.14 0 1 1 0-2.28h25.14a1.14 1.14 0 1 1 0 2.28M28.14 27.71H3a1.14 1.14 0 1 1 0-2.28h25.14a1.14 1.14 0 1 1 0 2.28M28.14 14H13.28a1.14 1.14 0 1 1 0-2.28h14.86a1.14 1.14 0 1 1 0 2.28M28.14 20.86H13.28a1.14 1.14 0 1 1 0-2.28h14.86a1.14 1.14 0 1 1 0 2.28M7.57 20.86 3 16.29l4.57-4.58z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M7.57 22c-.3 0-.59-.12-.81-.33L2.19 17.1a1.14 1.14 0 0 1 0-1.62l4.57-4.57c.33-.33.82-.42 1.25-.25.43.18.71.59.71 1.06v9.14a1.154 1.154 0 0 1-1.15 1.15Zm-2.95-5.71 1.81 1.81v-3.62z"
      })]
    })
  }));
};
OutdentIcon.displayName = 'OutdentIcon';